import { Agent, Channel, Merchant } from '@nemuru-eng/js-api-client';

export enum UserListColumn {
  ICON = 'icon',
  ROLES = 'roles',
}

export interface UserListTableProps {
  tableProps?: {
    users: Agent[] | Channel[] | Merchant[] | undefined;
    columnsToHide: UserListColumn[];
  };
}
